export default {
  ACTORS_CONTAINER: 'ACTORS_CONTAINER',
  METRICS_CONTAINER: 'METRICS_CONTAINER',
  GAMECOMPONENT_CONTAINER: 'GAMECOMPONENT_CONTAINER',
  HISTORY_CONTAINER: 'HISTORY_CONTAINER',
  DESKTOPFOOTER_CONTAINER: 'DESKTOPFOOTER_CONTAINER',
  GAMEENDBANNER_CONTAINER: 'GAMEENDBANNER_CONTAINER',
  GAMEENDBANNER_BANNER_TEXT: 'GAMEENDBANNER_BANNER_TEXT',
  GAMEENDBANNER_FEEDBACK_CLICK: 'GAMEENDBANNER_FEEDBACK_CLICK',
  GAMEENDBANNER_DOWNLOAD_CLICK: 'GAMEENDBANNER_DOWNLOAD_CLICK',
  GRAPHBOX_CONTAINER: 'GRAPHBOX_CONTAINER',
  INTROCOMPONENT_CONTAINER: 'INTROCOMPONENT_CONTAINER',
};

